export default "mutation bindKnowledge($bindInfo: KnowledgeBindRequest) {\n  bindKnowledge(bindInfo: $bindInfo) \n}";